import { useSnackbar } from 'notistack';
import useApiFetch from 'src/app/hooks/useApiFetch';
import ApiResponseBody from 'src/data/api/responses/ApiResponseBody';
import { EmptyBody } from 'src/data/models/common/emptyBody';
import ticketService from 'src/data/services/ticketService';
import ErrorsList from 'src/view/components/errors-list/ErrorsList';
import FormButtons from 'src/view/components/form/FormButtons';
import LoadingOverlay from 'src/view/components/loading-overlay/LoadingOverlay';

interface Props {
    ticketId?: string;
    ticketFileId?: string;
    onSucceed?: () => void;
}

export default function DeleteTicketFileFormDataWrapper({
    ticketId,
    ticketFileId,
    onSucceed,
}: Props): JSX.Element {
    const { enqueueSnackbar } = useSnackbar();

    const [{ loading, errors }, handleDeleteFile] = useApiFetch<ApiResponseBody<EmptyBody>>();

    const onDeleteConfirm = () => {
        if (!ticketId || !ticketFileId) return;

        handleDeleteFile(ticketService.deleteTicketFile(ticketFileId), {
            onSuccess: () => {
                enqueueSnackbar('File deleted successfully', { variant: 'success' });
                onSucceed?.();
            },
            useDefaultErrorHandler: true,
        });
    };

    return (
        <>
            <FormButtons
                buttons={[
                    {
                        children: 'Delete file',
                        onClick: onDeleteConfirm,
                    },
                ]}
            />
            {loading && <LoadingOverlay />}
            {errors.length > 0 && <ErrorsList errors={errors} />}
        </>
    );
}
